export const getShortcodeAttribute = (shortcode: string, name: string): string | undefined =>
    shortcode.match(new RegExp(`\\s${name}="([^"]*)"`))?.[1]
